import LabelTableCell from 'Components/LabelTableCell'
import StyledTableRow from 'Components/StyledTableRow'
import TranslatedField from 'Components/TranslatedField'
import type {
  ParameterGroup,
  ParameterGroupParameter
} from 'Services/ProductManagement/Features/Parameter/types'
import { CUSTOMER_GROUP_CATEGORY, IS_WALTTI_SERVICE_ENVIRONMENT } from 'Util/constants'
import { datetimeFormatter, showValueOrHyphen } from 'Util/formatters'
import { Paper, styled, Table, TableBody, TableCell, TableContainer } from '@mui/material'
import { t } from 'ttag'

const StyledTableCell = styled(LabelTableCell)`
  width: 40%;
`

interface ParameterDetailsProps {
  parameterGroupParameter: ParameterGroupParameter
  parameterGroup: ParameterGroup
}

export function ParameterDetails({
  parameterGroupParameter,
  parameterGroup
}: Readonly<ParameterDetailsProps>) {
  return (
    <TableContainer component={Paper}>
      <Table sx={{ td: { border: 'none' } }} aria-label={t`Parameter details table`}>
        <TableBody>
          <StyledTableRow>
            <StyledTableCell>{t`Identifier`}</StyledTableCell>
            <TableCell>{showValueOrHyphen(parameterGroupParameter.parameter_id)}</TableCell>
          </StyledTableRow>
          <StyledTableRow>
            <StyledTableCell>{t`Name`}</StyledTableCell>
            <TableCell>
              <TranslatedField
                key="parameter-name"
                field="value"
                translations={parameterGroupParameter.translations}
              />
            </TableCell>
          </StyledTableRow>
          {IS_WALTTI_SERVICE_ENVIRONMENT && parameterGroup.category === CUSTOMER_GROUP_CATEGORY && (
            <>
              <StyledTableRow>
                <StyledTableCell>{t`Minimum age`}</StyledTableCell>
                <TableCell>{showValueOrHyphen(parameterGroupParameter.minimum)}</TableCell>
              </StyledTableRow>
              <StyledTableRow>
                <StyledTableCell>{t`Maximum age`}</StyledTableCell>
                <TableCell>{showValueOrHyphen(parameterGroupParameter.maximum)}</TableCell>
              </StyledTableRow>
            </>
          )}
          <StyledTableRow>
            <StyledTableCell>{t`Modified`}</StyledTableCell>
            <TableCell>{datetimeFormatter(new Date(parameterGroup.modified_timestamp))}</TableCell>
          </StyledTableRow>
        </TableBody>
      </Table>
    </TableContainer>
  )
}
